import React, { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AuthModule from "modules/auth";
import PageTitle from "components/PageTitle";
import CompaniesRegistrationForm from "./CompaniesRegistrationForm";
import PagePreloader from "components/PagePreloader";
import { SITE_KEY } from "config/recaptcha";

const CompaniesRegistration = ({ reset, signUpPagesSlug, match, slugData }) => {
  useEffect(() => {
    signUpPagesSlug(match.params.slug);

    return () => reset();
  }, [signUpPagesSlug, reset, match.params.slug]);

  return !slugData ? (
    <PagePreloader isLoading />
  ) : (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <div className="page-body">
        <PageTitle align="center" isBackButton={true}>
          {slugData.content.title}
        </PageTitle>

        <div className="content-container">
          <div className="container">
            <CompaniesRegistrationForm slug={match.params.slug} />
          </div>
        </div>
      </div>
    </GoogleReCaptchaProvider>
  );
};

export default compose(
  connect(
    (state) => ({
      isFetching: state.auth.isFetching,
      isFetched: state.auth.isFetched,
      facilityData: state.auth.facilityData,
      slugData: state.auth.slugData,
    }),
    {
      signUpPagesSlug: AuthModule.signUpPagesSlug,
      reset: AuthModule.reset,
    }
  )
)(CompaniesRegistration);
